import apiClient from './client';

/**
 * GET /batches?product_id=X&has_stock=true
 *
 * Returns the batches for a product, optionally filtered to those with
 * available stock. Used by NewSale's batch picker — every sale line item
 * must be allocated against a specific batch so deliver can decrement stock
 * correctly (see backend/app/schemas/sale.py SaleLineItemCreate.batch_id).
 *
 * Response: BatchOut[] — each row has { id, product_id, order_number,
 * available_qty, ... }. The backend orders by id desc; callers that want FIFO
 * (oldest batch first) should sort ascending by id.
 */
export async function listBatches({ productId, hasStock = true } = {}) {
  const params = {};
  if (productId !== undefined && productId !== null) params.product_id = productId;
  if (hasStock !== undefined) params.has_stock = hasStock;
  const response = await apiClient.get('/batches', { params });
  return response.data; // BatchOut[]
}
